// Copied from `XDM-OLD/xdm.schema.ts` (do not modify old files).
// Keep the schema in `src/` so it can be bundled and used by the new implementation.
import * as v from 'valibot';

const LocusBus = v.object({
  locus_id: v.optional(v.nullable(v.string())),
  locus_type: v.optional(v.nullable(v.string())),
  country: v.optional(v.nullable(v.string())),
  locus_v2_id: v.optional(v.nullable(v.string())),
  locus_v2_type: v.optional(v.nullable(v.string())),
});

const LocationBus = v.object({
  code: v.optional(v.nullable(v.string())),
  name: v.optional(v.nullable(v.string())),
  country_code: v.optional(v.nullable(v.string())),
  country: v.optional(v.nullable(v.string())),
});

const FromBus = v.object({
  locus: v.optional(v.nullable(LocusBus)),
  location: v.optional(v.nullable(LocationBus)),
});

const ToBus = v.object({
  locus: v.optional(v.nullable(LocusBus)),
  location: v.optional(v.nullable(LocationBus)),
});

const SearchContextBus = v.object({
  from: v.optional(v.nullable(FromBus)),
  to: v.optional(v.nullable(ToBus)),
  from_date_time: v.optional(v.nullable(v.number())),
  search_type: v.optional(v.nullable(v.string())),
  trip_type: v.optional(v.nullable(v.string())),
  travel_class: v.optional(v.nullable(v.string())),
  pax: v.optional(
    v.nullable(
      v.object({
        count: v.optional(v.nullable(v.number())),
        details: v.optional(
          v.nullable(
            v.object({
              child: v.optional(
                v.nullable(
                  v.object({
                    count: v.optional(v.nullable(v.number())),
                    ages: v.optional(v.nullable(v.array(v.any()))),
                  }),
                ),
              ),
              adult: v.optional(
                v.nullable(
                  v.object({
                    count: v.optional(v.nullable(v.number())),
                  }),
                ),
              ),
              infant: v.optional(
                v.nullable(
                  v.object({
                    count: v.optional(v.nullable(v.number())),
                  }),
                ),
              ),
            }),
          ),
        ),
      }),
    ),
  ),
  advance_purchase: v.optional(v.nullable(v.string())),
});

const AddonDetailsItemBus = v.object({
  addon_type: v.optional(v.nullable(v.string())),
  addontype: v.optional(v.nullable(v.string())), // Alternative naming
  id: v.optional(v.nullable(v.string())),
  currency: v.optional(v.nullable(v.string())),
  included_units: v.optional(v.nullable(v.number())),
  unit_price: v.optional(v.nullable(v.number())),
  unitprice: v.optional(v.nullable(v.number())), // Alternative naming
  unit_type: v.optional(v.nullable(v.string())),
  heading: v.optional(v.nullable(v.string())),
  selected: v.optional(v.nullable(v.boolean())),
  available: v.optional(v.nullable(v.boolean())),
  is_preselected: v.optional(v.nullable(v.boolean())),
  discount: v.optional(v.nullable(v.number())),
});

const EventTrackingContextBus = v.object({
  bu: v.optional(v.nullable(v.string())),
  domain_country: v.optional(v.nullable(v.string())),
  domain_currency: v.optional(v.nullable(v.string())),
  domain_language: v.optional(v.nullable(v.string())),
  env: v.optional(v.nullable(v.string())),
  funnel_source: v.optional(v.nullable(v.string())),
  journey_id: v.optional(v.nullable(v.string())),
  organisation: v.optional(v.nullable(v.string())),
  session_id: v.optional(v.nullable(v.string())),
  session_visit_number: v.optional(v.nullable(v.number())),
  template_id: v.optional(v.nullable(v.number())),
  timezone: v.optional(v.nullable(v.string())),
  topic_name: v.optional(v.nullable(v.string())),
  traffic_source: v.optional(v.nullable(v.string())),
  user_preferred_currency: v.optional(v.nullable(v.string())),
  preferred_country: v.optional(v.nullable(v.string())),
});

const ProductListItemBus = v.object({
  id: v.optional(v.nullable(v.string())),
  name: v.optional(v.nullable(v.string())),
  rank: v.optional(v.nullable(v.number())),
  position: v.optional(
    v.nullable(v.object({ v: v.optional(v.nullable(v.number())) })),
  ),
  amenities: v.optional(v.nullable(v.array(v.any()))),
  attributes: v.optional(
    v.nullable(
      v.object({
        gps: v.optional(v.nullable(v.boolean())),
        isRTC: v.optional(v.nullable(v.boolean())),
      }),
    ),
  ),
  product_detail: v.optional(
    v.nullable(
      v.object({
        vendor_name: v.optional(v.nullable(v.string())),
        vendor_id: v.optional(v.nullable(v.string())),
        available_seats: v.optional(v.nullable(v.number())),
        min_fare: v.optional(v.nullable(v.number())),
        max_fare: v.optional(v.nullable(v.number())),
        rating: v.optional(v.nullable(v.number())),
        total_ratings: v.optional(v.nullable(v.number())),
        service_id: v.optional(v.nullable(v.string())),
        bus_type: v.optional(v.nullable(v.string())),
        model_type: v.optional(v.nullable(v.string())),
      }),
    ),
  ),
  travel_info: v.optional(
    v.nullable(
      v.object({
        travel_duration: v.optional(v.nullable(v.number())),
        start_time: v.optional(v.nullable(v.string())),
        end_time: v.optional(v.nullable(v.string())),
      }),
    ),
  ),
  price: v.optional(
    v.nullable(
      v.object({
        currency: v.optional(v.nullable(v.string())),
        base_fare: v.optional(v.nullable(v.number())),
        discounts: v.optional(
          v.nullable(
            v.object({
              red_deal_discount: v.optional(v.nullable(v.number())),
              discount: v.optional(v.nullable(v.number())),
            }),
          ),
        ),
      }),
    ),
  ),
});

const ComponentsBus = v.object({
  id: v.optional(v.nullable(v.string())),
  component_type: v.optional(v.nullable(v.string())),
  product_list: v.optional(v.nullable(v.array(ProductListItemBus))),
});

const BookingInfoBus = v.object({
  booking_id: v.optional(v.nullable(v.string())),
  status: v.optional(v.nullable(v.string())),
  applied_coupon: v.optional(v.nullable(v.string())),
});

const PaymentDetailsBus = v.object({
  payment_mode: v.optional(v.nullable(v.string())),
});

const TravellerInfoItemBus = v.object({
  age: v.optional(v.nullable(v.number())),
  gender: v.optional(v.nullable(v.string())),
  name: v.optional(v.nullable(v.string())),
});

const EventDetailBus = v.object({
  event_id: v.optional(v.nullable(v.string())),
  event_timestamp: v.optional(v.nullable(v.number())),
  event_name: v.optional(v.nullable(v.string())),
  event_type: v.optional(v.nullable(v.string())),
  event_value: v.optional(v.nullable(v.string())),
  components: v.optional(v.nullable(ComponentsBus)),
  booking_info: v.optional(v.nullable(BookingInfoBus)),
  payment_details: v.optional(v.nullable(PaymentDetailsBus)),
});

const ExperimentDetailsBus = v.object({
  valid_exp_list: v.optional(v.nullable(v.array(v.string()))),
  variant_keys: v.optional(v.nullable(v.string())),
  honoured_exp_list: v.optional(v.nullable(v.array(v.string()))),
});

const DeviceContextBus = v.object({
  acquired_country: v.optional(v.nullable(v.string())),
  advertiser_id: v.optional(v.nullable(v.string())),
  app_install_timestamp: v.optional(v.nullable(v.number())),
  app_ver: v.optional(v.nullable(v.string())),
  build_ver: v.optional(v.nullable(v.string())),
  continent: v.optional(v.nullable(v.string())),
  country: v.optional(v.nullable(v.string())),
  device_id: v.optional(v.nullable(v.string())),
  firebase_id: v.optional(v.nullable(v.string())),
  ip_addr: v.optional(v.nullable(v.string())),
  model: v.optional(v.nullable(v.string())),
  network_type: v.optional(v.nullable(v.string())),
  os: v.optional(v.nullable(v.string())),
  os_version: v.optional(v.nullable(v.string())),
  platform: v.optional(v.nullable(v.string())),
  time_zone: v.optional(v.nullable(v.string())),
  user_agent: v.optional(v.nullable(v.string())),
  vendor_id: v.optional(v.nullable(v.string())),
  visitor_id: v.optional(v.nullable(v.string())),
});

const UserContextBus = v.object({
  is_logged_in: v.optional(v.nullable(v.boolean())),
  profile_type: v.optional(v.nullable(v.string())),
  login_channel: v.optional(v.nullable(v.string())),
  login_type: v.optional(v.nullable(v.string())),
  loyalty_status: v.optional(v.nullable(v.string())),
  loyalty_type: v.optional(v.nullable(v.string())),
  loyalty_level: v.optional(v.nullable(v.string())),
  wallet_bal: v.optional(v.nullable(v.number())),
  uuid: v.optional(v.nullable(v.string())),
});

const EntityInfoBus = v.object({
  currency: v.optional(v.nullable(v.string())),
  entity: v.optional(v.nullable(v.string())),
  organisation: v.optional(v.nullable(v.string())),
  region: v.optional(v.nullable(v.string())),
  user_country: v.optional(v.nullable(v.string())),
  user_currency: v.optional(v.nullable(v.string())),
  user_language: v.optional(v.nullable(v.string())),
});

const PageContextBus = v.object({
  lob: v.optional(v.nullable(v.string())),
  page_type: v.optional(v.nullable(v.string())),
  page_name: v.optional(v.nullable(v.string())),
  funnel_step: v.optional(v.nullable(v.string())),
  lob_category: v.optional(v.nullable(v.string())),
  prev_page_name: v.optional(v.nullable(v.string())),
  page_title: v.optional(v.nullable(v.string())),
  page_url: v.optional(v.nullable(v.string())),
  travel_store: v.optional(
    v.nullable(
      v.object({
        store_id: v.optional(v.nullable(v.string())),
      }),
    ),
  ),
});

const IdentitiesBus = v.object({
  phone_number_hash: v.optional(v.nullable(v.string())),
  email_address_hash: v.optional(v.nullable(v.string())),
});

// Bus XDM Base Schema - For XDM logging
export const BusXDMBaseSchema = v.object({
  page_context: v.optional(v.nullable(PageContextBus)),
  event_tracking_context: v.optional(v.nullable(EventTrackingContextBus)),
  search_context: v.optional(v.nullable(SearchContextBus)),
  event_detail: v.optional(v.nullable(EventDetailBus)),
  addon_details: v.optional(v.nullable(v.array(AddonDetailsItemBus))),
  traveller_info: v.optional(v.nullable(v.array(TravellerInfoItemBus))),
  experiment_details: v.optional(v.nullable(ExperimentDetailsBus)),
  device_context: v.optional(v.nullable(DeviceContextBus)),
  user_context: v.optional(v.nullable(UserContextBus)),
  entity_info: v.optional(v.nullable(EntityInfoBus)),
  identities: v.optional(v.nullable(IdentitiesBus)),
});
